/** 跨组件复用的 Tailwind 类名常量 */

export const gradientBtn =
  'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 bg-gradient-to-br from-[#07F4F2] to-[#C1FAB8] text-[#0a0a0a] border-none shadow-[0_4px_16px_-4px_rgba(7,244,242,0.35)] hover:from-[#1af8f6] hover:to-[#d4fccf] hover:shadow-[0_6px_24px_-4px_rgba(7,244,242,0.5)] hover:-translate-y-px active:translate-y-0 disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none'

export const panelActionBtn =
  'inline-flex items-center justify-center gap-1 rounded-md text-xs font-medium transition-all duration-200 bg-zinc-800 text-zinc-300 border border-zinc-700 shadow-none hover:bg-gradient-to-br hover:from-[#1af8f6] hover:to-[#d4fccf] hover:text-[#0a0a0a] hover:border-transparent hover:shadow-[0_4px_16px_-2px_rgba(7,244,242,0.45)] hover:-translate-y-px'

export const panelActionBtnPlain = 'border-none'

export const panelActionBtnActive =
  'bg-gradient-to-br from-[#07F4F2] to-[#C1FAB8] text-[#0a0a0a] border-none shadow-[0_2px_12px_-2px_rgba(7,244,242,0.35)]'

export const formInput =
  'w-full rounded-xl px-4 py-2.5 text-sm text-white placeholder:text-zinc-600 transition-all duration-200 bg-black/35 border border-white/10 focus:outline-none focus:border-[#07F4F2]/40 focus:shadow-[0_0_0_3px_rgba(7,244,242,0.1)] focus-visible:ring-0 focus-visible:ring-offset-0'

export const formSelectTrigger =
  'w-full justify-between rounded-xl px-4 py-2.5 text-sm font-normal text-white bg-black/35 border border-white/10 shadow-none h-auto min-h-10 hover:bg-black/45 hover:text-white focus:outline-none focus:border-[#07F4F2]/40 focus:shadow-[0_0_0_3px_rgba(7,244,242,0.1)] focus:ring-0 focus:ring-offset-0'

export const formSelectContent =
  'rounded-xl overflow-hidden bg-[rgba(18,18,18,0.98)] border border-white/10 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.8)]'

export const formSelectItem = 'rounded-lg text-zinc-300 focus:bg-[#07F4F2]/10 focus:text-white'

export const formSelectSearch =
  'rounded-lg text-sm text-white placeholder:text-zinc-600 bg-black/35 border border-white/10 focus-visible:outline-none focus-visible:border-[#07F4F2]/40 focus-visible:shadow-[0_0_0_3px_rgba(7,244,242,0.1)] focus-visible:ring-0 focus-visible:ring-offset-0'

export const formSelectOption = 'rounded-lg text-zinc-300 focus:bg-[#07F4F2]/10 outline-none'

export const formSelectOptionSelected = 'bg-[#07F4F2]/12'

export const dialogShell =
  'border-0 p-0 overflow-hidden gap-0 bg-[rgba(18,18,18,0.95)] backdrop-blur-xl shadow-[0_24px_64px_-12px_rgba(0,0,0,0.8),0_0_0_1px_rgba(255,255,255,0.06)] [&>button[class*="absolute"]]:top-4 [&>button[class*="absolute"]]:right-4 [&>button[class*="absolute"]]:z-10 [&>button[class*="absolute"]]:rounded-full [&>button[class*="absolute"]]:w-8 [&>button[class*="absolute"]]:h-8 [&>button[class*="absolute"]]:flex [&>button[class*="absolute"]]:items-center [&>button[class*="absolute"]]:justify-center [&>button[class*="absolute"]]:bg-white/10 [&>button[class*="absolute"]]:opacity-100 [&>button[class*="absolute"]]:text-white/60 [&>button[class*="absolute"]]:transition-all [&>button[class*="absolute"]]:hover:bg-white/20 [&>button[class*="absolute"]]:hover:text-white'

export const dialogHeader = 'flex-shrink-0 px-6 pt-6 pb-4 pr-14 text-left space-y-2'

export const dialogBody = 'px-6 py-4 space-y-4'

export const dialogScroll =
  'flex-1 min-h-0 overflow-y-auto scrollbar-hide'

export const dialogFooter =
  'flex-shrink-0 flex justify-end gap-3 px-6 py-4 bg-black/25 border-t border-white/10'

export const cancelBtn =
  'rounded-full px-5 py-2 text-sm font-medium transition-all duration-200 bg-white/10 text-white/70 border border-white/10 hover:bg-white/15 hover:text-white'

export const blockCard = 'rounded-xl p-4 space-y-3 bg-white/[0.03] border border-white/10'

export const episodeSelected =
  'bg-gradient-to-br from-[#1af8f6] to-[#d4fccf] border-none text-[#0a0a0a] shadow-[0_4px_16px_-2px_rgba(7,244,242,0.45)]'

export const seriesGradientBtn =
  'inline-flex items-center justify-center gap-1 rounded-md text-xs font-medium transition-all duration-200 cursor-pointer h-7 px-3 bg-gradient-to-br from-[#07F4F2] to-[#C1FAB8] text-[#0a0a0a] border-none shadow-[0_2px_12px_-2px_rgba(7,244,242,0.35)] hover:from-[#1af8f6] hover:to-[#d4fccf] hover:shadow-[0_4px_16px_-2px_rgba(7,244,242,0.45)] hover:-translate-y-px'

/** 素材选择弹窗 Tab */
export const selectorTabList =
  'inline-flex h-auto w-full justify-start gap-1 rounded-xl p-1 bg-black/35 border border-white/10'

export const selectorTabTrigger =
  'rounded-lg px-4 py-2 text-sm font-medium text-zinc-400 transition-all duration-200 bg-transparent border-none shadow-none data-[state=active]:bg-gradient-to-br data-[state=active]:from-[#07F4F2] data-[state=active]:to-[#C1FAB8] data-[state=active]:text-[#0a0a0a] data-[state=active]:shadow-[0_2px_12px_-2px_rgba(7,244,242,0.35)] hover:text-zinc-200'

export const assetCardSelected = 'border-[#07F4F2] ring-2 ring-[#07F4F2]/40'

export const assetCardDefault = 'border-white/10 group-hover:border-[#07F4F2]/30'

export const assetCheckSelected = 'border-[#07F4F2] bg-[#07F4F2] text-[#0a0a0a]'

export const assetCheckDefault =
  'border-white/70 bg-black/30 hover:bg-[#07F4F2] hover:border-[#07F4F2] hover:text-[#0a0a0a]'

export const filterChipActive = 'bg-[#07F4F2]/10 text-[#07F4F2]'

export const filterChipDefault = 'bg-black/25 text-zinc-400 hover:bg-white/10 hover:text-zinc-300'

/** 提示词来源标签 */
export const promptSourceBadgeSystem =
  'border-[#07F4F2]/25 bg-[#07F4F2]/10 text-[#07F4F2] shadow-none transition-colors duration-200 hover:bg-[#07F4F2]/20 hover:border-[#07F4F2]/45 hover:text-[#1af8f6]'

export const promptSourceBadgeUser =
  'border-white/10 bg-white/[0.06] text-zinc-400 shadow-none transition-colors duration-200 hover:bg-[#07F4F2]/8 hover:border-[#07F4F2]/30 hover:text-[#C1FAB8]'

/** 确认弹窗壳 */
export const alertDialogShell =
  'rounded-xl border-0 bg-[rgba(18,18,18,0.95)] backdrop-blur-xl text-zinc-100 shadow-[0_24px_64px_-12px_rgba(0,0,0,0.8),0_0_0_1px_rgba(255,255,255,0.06)]'

/** 确认弹窗按钮（无 hover 发光，避免与红色删除按钮冲突） */
export const alertDialogActionBtn =
  'inline-flex items-center justify-center rounded-md h-9 px-5 text-sm font-medium transition-colors duration-200 bg-gradient-to-br from-[#07F4F2] to-[#C1FAB8] text-[#0a0a0a] border-none shadow-none hover:from-[#1af8f6] hover:to-[#d4fccf] hover:shadow-none disabled:opacity-60 disabled:cursor-not-allowed'

export const alertDialogCancelBtn =
  'inline-flex items-center justify-center rounded-md h-9 px-5 text-sm font-medium transition-colors duration-200 bg-white/10 text-white/70 border border-white/10 shadow-none hover:bg-white/15 hover:text-white hover:shadow-none'

export const alertDialogDestructiveBtn =
  'inline-flex items-center justify-center rounded-md h-9 px-5 text-sm font-medium transition-colors duration-200 bg-gradient-to-br from-red-500/90 to-red-500/90 text-white border-none shadow-none hover:from-red-600 hover:to-red-600 hover:shadow-none disabled:opacity-50 disabled:cursor-not-allowed'

/** 认证页（登录 / 注册 / 找回密码） */
export const authCard =
  'bg-white/[0.03] backdrop-blur-xl border border-white/10 rounded-2xl p-6 sm:p-8 shadow-[0_24px_64px_-12px_rgba(0,0,0,0.8),0_0_0_1px_rgba(255,255,255,0.06)]'

export const authIconBox =
  'rounded-xl bg-gradient-to-br from-[#07F4F2] to-[#C1FAB8] flex items-center justify-center shadow-lg shadow-[#07F4F2]/25 transform hover:scale-105 transition-transform duration-300'

export const authLink = 'text-[#07F4F2] hover:text-[#1af8f6] font-medium transition-colors'

export const authInputIcon = 'text-zinc-500 group-focus-within:text-[#07F4F2] transition-colors'

export const authFormInput = `${formInput} pl-10 h-11`

export const authCodeBtn =
  'inline-flex items-center justify-center h-11 px-6 min-w-[120px] rounded-xl text-sm font-medium transition-all duration-200 bg-black/35 text-zinc-300 border border-white/10 hover:bg-white/10 hover:text-white hover:border-[#07F4F2]/30 disabled:opacity-50 disabled:cursor-not-allowed'

export const authSubmitBtn = `${gradientBtn} w-full h-11 !rounded-xl text-base font-medium gap-2`
